import { useTranslation } from "react-i18next";
import "./Contact.css";

export default function Contact() {
  const { t } = useTranslation();
  return (
    <section id="contato" className="contact section">
      <div className="container contact__inner">
        <div className="contact__copy">
          <span className="contact__eyebrow">{t("contact.eyebrow")}</span>
          <h2 className="contact__title">{t("contact.title")}</h2>
          <p className="contact__lead">{t("contact.lead")}</p>
          <div className="contact__actions">
            <a
              href="mailto:contato@niertechsolutions.com.br"
              className="btn btn--primary"
            >
              {t("contact.send_email")}
            </a>
            <a
              href="https://github.com/Niertech-Solutions"
              className="btn btn--outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("contact.view_github")}
            </a>
          </div>
        </div>

        <aside className="contact__card">
          <dl className="contact__list">
            <div className="contact__row">
              <dt>{t("contact.labels.email")}</dt>
              <dd>
                <a href="mailto:contato@niertechsolutions.com.br">
                  contato@niertechsolutions.com.br
                </a>
              </dd>
            </div>
            <div className="contact__row">
              <dt>{t("contact.labels.github")}</dt>
              <dd>
                <a
                  href="https://github.com/Niertech-Solutions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Niertech-Solutions
                </a>
              </dd>
            </div>
            <div className="contact__row">
              <dt>{t("contact.labels.address")}</dt>
              <dd>
                Avenida Paulista, 1483 — Conj. 1012
                <br />
                Bela Vista, São Paulo/SP
                <br />
                01311-200
              </dd>
            </div>
            <div className="contact__row">
              <dt>{t("contact.labels.cnpj")}</dt>
              <dd>64.745.677/0001-31</dd>
            </div>
          </dl>
        </aside>
      </div>
    </section>
  );
}
